import Icon from "@amzn/meridian/icon";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";
import clockTokens from "@amzn/meridian-tokens/base/icon/clock";
import documentTokens from "@amzn/meridian-tokens/base/icon/document";
import exportSmallTokens from "@amzn/meridian-tokens/base/icon/export-small";
import folderTokens from "@amzn/meridian-tokens/base/icon/folder";
import { formatDate, formatFileSize, policyLink } from "../adminReportUtils";
import { PolicyDocument } from "../types";
import Chip from "./chip";

const DocumentDescription = ({ document }: { document: PolicyDocument }) => {
  const folders = document.nodeFullPath.split("/");
  const link = policyLink(document);

  return (
    <>
      <div className="admin-report__meta">
        <div className="admin-report__meta-key">
          <span aria-hidden="true">#</span>Policy ID
        </div>
        <div className="admin-report__meta-value">
          <Chip tone="neutral" monospace>
            {document.policyId}
          </Chip>
        </div>

        <div className="admin-report__meta-key">
          <Icon tokens={exportSmallTokens} />
          Policy Link
        </div>
        <div className="admin-report__meta-value">
          {link ? (
            <a
              className="admin-report__meta-link"
              href={link}
              target="_blank"
              rel="noreferrer"
            >
              {link}
            </a>
          ) : (
            <span className="admin-report__doc-sub">
              Not available for this record
            </span>
          )}
        </div>

        <div className="admin-report__meta-key">
          <Icon tokens={folderTokens} />
          Folder
        </div>
        <div className="admin-report__folder-path">
          {folders.map((segment, index) => (
            <span key={`${index}-${segment}`}>
              {index > 0 && <span aria-hidden="true">{" / "}</span>}
              <span
                className={
                  index === folders.length - 1
                    ? "admin-report__folder-leaf"
                    : ""
                }
              >
                {segment}
              </span>
            </span>
          ))}
        </div>

        <div className="admin-report__meta-key">
          <Icon tokens={documentTokens} />
          File
        </div>
        <div className="admin-report__meta-value">
          {[
            document.fileName,
            // formatFileSize(0) reads "1 KB", so an absent size is omitted
            // rather than reported as a real one.
            document.sizeBytes > 0 && formatFileSize(document.sizeBytes),
            document.language && document.language.toUpperCase(),
          ]
            .filter(Boolean)
            .join(" · ") || "—"}
        </div>

        {document.excludeReason && (
          <>
            <div className="admin-report__meta-key">
              <Icon tokens={alertTokens} />
              Excluded
            </div>
            <div className="admin-report__meta-value">
              {document.excludeReason}
            </div>
          </>
        )}

        <div className="admin-report__meta-key">
          <Icon tokens={clockTokens} />
          Last Modified
        </div>
        <div className="admin-report__meta-value">
          {[
            formatDate(document.lastModifiedAt),
            document.lastSeenAt &&
              `last seen ${formatDate(document.lastSeenAt)}`,
          ]
            .filter(Boolean)
            .join(" · ") || "—"}
        </div>
      </div>

      {document.nodeDescription && (
        <p className="admin-report__description">{document.nodeDescription}</p>
      )}
    </>
  );
};

export default DocumentDescription;
